import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccuracyCountStringPipe } from './accuracy-count-string.pipe';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
  declarations: [AccuracyCountStringPipe],
  imports: [
    DisableAutocompleteDirectiveModule,
    CommonModule
  ],
  exports: [AccuracyCountStringPipe]
})
export class AccuracyCountStringPipeModule { }
